// src/pages/EditarUsuario.jsx - Edición de Usuario COMPATIBLE MUI v7 + React 19
// Sistema de columnas usando Box + Flexbox (NO Grid tradicional)
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Container,
  Card,
  CardContent,
  CardHeader,
  Typography,
  TextField,
  Button,
  Box,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Slide,
  CircularProgress,
  Alert,
  Input,
  MenuItem
} from '@mui/material';

import {
  Contacts as ContactsIcon,
  HomeWork as HomeWorkIcon,
  PermContactCalendar as PermContactCalendarIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Lock as LockIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Close as CloseIcon,
  Info as InfoIcon,
  PhotoCamera as PhotoCameraIcon,
  ArrowBack as ArrowBackIcon,
  Visibility as VisibilityIcon,
  FileDownload,
  ContentCopy
} from '@mui/icons-material';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { v4 as uuidv4 } from 'uuid';
import chroma from 'chroma-js';
import Swal from 'sweetalert2';

import {
  getUsuarioById,
  actualizarUsuario,
  getRoles,
  getDireccionById,
  agregarDireccion,
  eliminarDireccion,
  actualizarDireccion,
  actualizarRoles
} from '../../actions/UsuarioAction';
import { getNotaById } from '../../actions/NotaAction';
import { obtenerDepartamentos, obtenerMunicipios } from '../../actions/EntidadAction';
import RatingComponent from '../../components/objects/RatingComponentAlianza';
import QRCardComponent from '../../components/objects/QRCardComponent';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    '& fieldset': {
      borderColor: 'rgba(30, 136, 229, 0.3)',
      borderWidth: '2px',
    },
    '&:hover fieldset': {
      borderColor: '#1E88E5',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1E88E5',
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#757575',
    '&.Mui-focused': {
      color: '#1E88E5',
    },
  },
};

const ImageUploader = ({ onImageChange, imageUrl }) => {
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: 'error',
        title: 'Formato inválido',
        text: 'Solo se permiten archivos JPG, PNG o GIF',
      });
      return;
    }

    if (file.size > 5242880) {
      Swal.fire({
        icon: 'error',
        title: 'Archivo muy grande',
        text: 'El tamaño máximo es 5MB',
      });
      return;
    }

    onImageChange(file);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mb: 2,
        cursor: 'pointer'
      }}
      onClick={handleImageClick}
    >
      <Avatar
        src={imageUrl}
        sx={{
          width: 150,
          height: 150,
          border: '4px solid #1E88E5',
          transition: 'all 0.3s',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 8px 16px rgba(30, 136, 229, 0.4)'
          }
        }}
      />
      <Tooltip title="Cambiar foto" arrow>
        <IconButton
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 'calc(50% - 85px)',
            backgroundColor: '#1E88E5',
            color: 'white',
            '&:hover': {
              backgroundColor: '#1565C0'
            }
          }}
        >
          <PhotoCameraIcon />
        </IconButton>
      </Tooltip>
      <Input
        type="file"
        inputRef={fileInputRef}
        sx={{ display: 'none' }}
        onChange={handleFileChange}
        inputProps={{
          accept: 'image/jpeg,image/jpg,image/png,image/gif'
        }}
      />
    </Box>
  );
};

const EditarUsuario = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const transitionRef = useRef(null);
  const animatedComponents = makeAnimated();

  const imagenDefault = "https://tottope.vteximg.com.br/arquivos/ids/167188-1000-1000/PILIGRAM-H-1810-V07_A.png?v=636723781789170000";

  const color = chroma("#f8f9f9");
  const color1 = chroma("#494949");

  const [loading, setLoading] = useState(false);

  const [usuario, setUsuario] = useState({
    id: '', nombre: '', apellido: '', imagen: '', password: '',
    file: '', imagenTemporal: '', roles: [], userName: '',
    tipoDocumento: '', documento: '', phoneNumber: '',
    contacto1: '', celularC1: '', email: '',
    lockoutEnabled: false, esBloqueado: false,
    departamentoID: '', municipioID: '', departamento: '', municipio: ''
  });

  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [municipiosFiltrados, setMunicipiosFiltrados] = useState([]);
  
  const [roles, setRoles] = useState([]);
  const [rolesInicialesAsignados, setRolesInicialesAsignados] = useState([]);
  const [rolesAsignados, setRolesAsignados] = useState([]);
  
  const [direcciones, setDirecciones] = useState([]);
  
  const [widthMin, setWidthMin] = useState(0);

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogRoles, setOpenDialogRoles] = useState(false);
  const [openDialogNota, setOpenDialogNota] = useState(false);
  const [openPass, setOpenPass] = useState(false);
  
  const [direccion, setDireccion] = useState({
    id: null, calle: '', ciudad: '', departamento: '',
    codigoPostal: '', pais: '', caracteristica: '', principal: false
  });

  const [nota, setNota] = useState({
    idNota: 0, idTipoNota: 0, idEntidad: 0,
    contenido: '', fecha: '', idUser: '',
  });

  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [scroll, setScroll] = useState('paper');

  // Estado para el rating del usuario (datos por defecto mientras no haya API)
  const [userRating, setUserRating] = useState({
    promedio: 4.5,
    cantidadRegistros: 128
  });

  const customStyles = () => ({
    menuList: () => ({ 
      maxHeight: 'none', 
      fontFamily: 'inherit'
    }),
    control: (provided, state) => ({
      ...provided,
      fontFamily: 'inherit',
      backgroundColor: color.alpha(1).css(),
      minWidth: `${widthMin}px`,
      borderRadius: '12px',
      borderColor: state.isFocused ? '#1E88E5' : 'rgba(30, 136, 229, 0.3)',
      borderWidth: '2px',
      '&:hover': { borderColor: '#1E88E5' },
    }),
    multiValue: (styles) => ({
      ...styles,
      color: color1.alpha(1).css(),
      backgroundColor: color.alpha(0.1).css(),
      borderRadius: '8px',
    }),
    multiValueLabel: (styles) => ({ ...styles, color: color1.alpha(1).css() }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: '#757575',
      ':hover': { backgroundColor: '#E63946', color: 'white' },
    }),
  });

  useEffect(() => {
    cargarDatosUsuario();
    cargarRoles();
    cargarDirecciones();
    cargarCatalogos();
  }, [id]);

  const cargarCatalogos = async () => {
    try {
      const departamentosResponse = await obtenerDepartamentos();
      if (departamentosResponse.status === 200) {
        setDepartamentos(departamentosResponse.data);
      }
      const municipiosResponse = await obtenerMunicipios();
      if (municipiosResponse.status === 200) {
        setMunicipios(municipiosResponse.data);
      }
    } catch (error) {
      console.error('Error cargando catálogos:', error);
    }
  };

  const cargarDatosUsuario = async () => {
    try {
      setLoading(true);
      const response = await getUsuarioById(id);
      setLoading(false);
      
      if (response && response.data) {
        setUsuario({
          id: response.data.id ?? '', nombre: response.data.nombre ?? '',
          apellido: response.data.apellido ?? '', imagen: response.data.imagen ?? '',
          password: response.data.password ?? '', file: response.data.file ?? '',
          imagenTemporal: response.data.imagenTemporal ?? '',
          roles: response.data.roles ?? [], userName: response.data.userName ?? '', 
          tipoDocumento: response.data.tipoDocumento ?? '',
          documento: response.data.documento ?? '', phoneNumber: response.data.phoneNumber ?? '',
          contacto1: response.data.contacto1 ?? '', celularC1: response.data.celularC1 ?? '',
          email: response.data.email ?? '', lockoutEnabled: response.data.lockoutEnabled ?? false,
          esBloqueado: response.data.esBloqueado ?? false,
          departamentoID: response.data.departamentoID ?? '',
          municipioID: response.data.municipioID ?? '',
          departamento: response.data.departamento ?? '',
          municipio: response.data.municipio ?? ''
        });
        
        // TODO: Cuando esté disponible el API de rating, descomentar:
        // if (response.data.rating) {
        //   setUserRating({
        //     promedio: response.data.rating.promedio ?? 4.5,
        //     cantidadRegistros: response.data.rating.cantidadRegistros ?? 128
        //   });
        // }
      }
    } catch (error) {
      setLoading(false);
      console.error('Error cargando usuario:', error);
      setErrorMessage('Error al cargar los datos del usuario');
    }
  };

  const cargarRoles = async () => {
    try {
      const response = await getRoles();
      setRoles(response.data);
    } catch (error) {
      console.error('Error cargando roles:', error);
    }
  };

  const cargarDirecciones = async () => {
    try {
      const response = await getDireccionById(id);
      setDirecciones(response.data);
    } catch (error) {
      console.error('Error cargando direcciones:', error);
    }
  };

  // Filtrar municipios cuando cambia el departamento
  useEffect(() => {
    if (usuario.departamentoID) {
      const municipiosDelDepartamento = municipios.filter(
        m => m.departamentoID === parseInt(usuario.departamentoID)
      );
      setMunicipiosFiltrados(municipiosDelDepartamento);
    } else {
      setMunicipiosFiltrados([]);
    }
    
    // Limpiar selección de municipio si cambia el departamento
    if (usuario.municipioID && usuario.departamentoID) {
      const municipioSeleccionado = municipios.find(m => m.municipioID === parseInt(usuario.municipioID));
      if (municipioSeleccionado && municipioSeleccionado.departamentoID !== parseInt(usuario.departamentoID)) {
        setUsuario(prev => ({ ...prev, municipioID: '' }));
      }
    }
  }, [usuario.departamentoID, municipios, usuario.municipioID]);

  useEffect(() => {
    if (usuario && usuario.roles && roles.length > 0) {
      const preselectedRoles = usuario.roles.map(rolNombre => {
        const rol = roles.find(r => r.name === rolNombre);
        return rol ? { value: rol.id, label: rol.name } : null;
      }).filter(Boolean);
      
      setRolesAsignados(preselectedRoles);
      setRolesInicialesAsignados(preselectedRoles);
      setWidthMin(Math.max(...roles.map(role => role.name.length * 10)));
    }
  }, [usuario, roles]);

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setUsuario(prev => ({
      ...prev,
      [name]: name === 'esBloqueado' ? checked : value
    }));
  };

  const handleImageChange = (file) => {
    let fotoUrl = "";
    try {
      fotoUrl = URL.createObjectURL(file);
    } catch (e) {
      console.log(e);
    }
    setUsuario(prev => ({ ...prev, file: file, imagenTemporal: fotoUrl }));
  };

  const guardarUsuario = async (e) => {
    e.preventDefault();
    
    // Obtener nombres de departamento y municipio
    const departamentoSeleccionado = departamentos.find(d => d.departamentoID === parseInt(usuario.departamentoID));
    const municipioSeleccionado = municipios.find(m => m.municipioID === parseInt(usuario.municipioID));
    
    const usuarioActualizado = {
      ...usuario,
      roles: rolesAsignados.map(item => item.label),
      departamento: departamentoSeleccionado?.nombre || '',
      municipio: municipioSeleccionado?.nombre || ''
    };

    try {
      setLoading(true);
      const response = await actualizarUsuario(id, usuarioActualizado, dispatch);
      setLoading(false);
      setOpenPass(false);
      
      if (response.status === 200) {
        setSuccessMessage('Datos de usuario actualizados exitosamente');
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        setErrorMessage('Errores actualizando el perfil de usuario');
      }
    } catch (error) {
      setLoading(false);
      console.error('Hubo un problema al actualizar el usuario:', error);
      setErrorMessage('Error al actualizar el usuario');
    }
  };

  const cancelaGuardar = async (e) => {
    e.preventDefault();
    await cargarDatosUsuario();
    await cargarDirecciones();
  };

  const handleVolver = () => {
    navigate('/admin/users');
  };

  const handleOpenDialog = (dir) => { setDireccion(dir); setOpenDialog(true); };
  const handleCloseDialog = () => { setOpenDialog(false); };
  const handleChangeDir = (e) => {
    const { name, value, checked } = e.target;
    setDireccion(prev => ({ ...prev, [name]: name === 'principal' ? checked : value }));
  };

  const handleGuardar = async (direccion) => {
    if (direccion.id) {
      const response = await actualizarDireccion(id, direccion);
      if (response.status === 200) setDirecciones(response.data);
    } else {
      const response = await agregarDireccion(id, direccion);
      if (response.status === 200) setDirecciones(response.data);
    }
    handleCloseDialog();
  };

  const handleEliminarDireccion = (direccionDelete) => {
    Swal.fire({
      title: 'Ã‚Â¿Eliminar dirección?',
      html: `${direccionDelete.calle}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar!',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await eliminarDireccion(id, direccionDelete);
        if (response.status === 200) setDirecciones(direcciones.filter(d => d.id !== direccionDelete.id));
      }
    });
  };

  const handleOpenDialogRoles = () => setOpenDialogRoles(true);
  const handleCloseDialogRoles = () => { setRolesAsignados(rolesInicialesAsignados); setOpenDialogRoles(false); };
  const handleGuardarRoles = async (rolesAsignados) => {
    const response = await actualizarRoles(id, rolesAsignados.map(item => item.label));
    if (response.status === 200) setSuccessMessage('Roles modificados');
    setOpenDialogRoles(false);
  };
  const handleChangeRoles = selectedOptions => setRolesAsignados(selectedOptions);

  const handleOpenDialogNotas = async (idNota, scrollType) => {
    const response = await getNotaById(idNota);
    if (response.status === 200) setNota(response.data);
    setOpenDialogNota(true);
    setScroll(scrollType);
  };
  const handleCloseDialogNota = () => setOpenDialogNota(false);

  const handleOpenPassword = () => setOpenPass(true);
  const handleClosePassword = () => setOpenPass(false);
  const handleChangeConfirm = (e) => {
    const { value } = e.target;
    if (value === usuario.password) {
      setConfirmPassword(value);
      setError('');
    } else {
      setError('Las contraseñas no coinciden');
    }
  };

  const NoDropdownIndicator = props => null;
  const NoClearIndicator = props => null;
  const NoMultiValueRemove = props => null;

  const optionsRoles = roles.map(rol => ({ value: rol.id, label: rol.name }));

  return (
    <Container 
      maxWidth="xl" 
      sx={{ 
        mt: 7, mb: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.35)',
        backdropFilter: 'blur(10px)',
        borderRadius: '24px',
        padding: '32px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.38)',
        position: 'relative'
      }}
    >
      {loading && (
        <Box sx={{
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '24px', zIndex: 9999
        }}>
          <CircularProgress size={60} sx={{ color: '#1E88E5' }} />
        </Box>
      )}

      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: '12px' }} onClose={() => setSuccessMessage('')}>
          {successMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: '12px' }} onClose={() => setErrorMessage('')}>
          {errorMessage}
        </Alert>
      )}

      {/* ==================== SISTEMA DE COLUMNAS CON BOX + FLEXBOX ==================== */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, width: '100%' }}>
        
        {/* ==================== COLUMNA IZQUIERDA 2/12 ==================== */}
        <Box sx={{ 
          width: { xs: '100%', md: '16.66%' },
          minWidth: { xs: '100%', md: '280px' },
          maxWidth: { xs: '100%', md: '300px' },
          flexShrink: 0
        }}>
          <Card sx={{ borderRadius: '16px', border: '2px solid rgba(30, 136, 229, 0.2)', height: '100%' }}>
            <CardContent sx={{ pt: 4 }}>
              <ImageUploader
                onImageChange={handleImageChange}
                imageUrl={usuario.imagenTemporal || usuario.imagen || imagenDefault}
              />
              
              {/* Rating del usuario */}
              <RatingComponent 
                value={userRating.promedio} 
                cantidad={userRating.cantidadRegistros} 
              />
              
              <Divider sx={{ my: 2 }} />
              
              <TextField label="Nombre" variant="outlined" fullWidth sx={{ ...textFieldStyles, mb: 2 }}
                name="nombre" value={usuario.nombre} onChange={handleChange} />
              <TextField label="Apellidos" variant="outlined" fullWidth sx={{ ...textFieldStyles, mb: 2 }}
                name="apellido" value={usuario.apellido} onChange={handleChange} />
              <TextField variant="outlined" disabled fullWidth sx={{ ...textFieldStyles, mb: 2 }}
                value={usuario.email} name="email" />
              <TextField label="Celular" variant="outlined" fullWidth sx={{ ...textFieldStyles, mb: 2 }}
                value={usuario.phoneNumber} name="phoneNumber" onChange={handleChange} />
              
              <Divider sx={{ my: 2 }} />
              
              <List>
                <ListItem button sx={{ 
                  borderRadius: '12px', 
                  mb: 1,
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.08)'
                  }
                }}>
                  <ListItemText primary={<Typography variant="body2" fontWeight="bold">Actualizar contraseña</Typography>} />
                  <ListItemSecondaryAction>
                    <Tooltip title="Cambiar contraseña" arrow>
                      <IconButton edge="end" onClick={handleOpenPassword} sx={{ color: '#1E88E5' }}>
                        <LockIcon />
                      </IconButton>
                    </Tooltip>
                  </ListItemSecondaryAction>
                </ListItem>
                
                <ListItem button sx={{ 
                  borderRadius: '12px',
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.08)'
                  }
                }}>
                  <ListItemText
                    primary={<Typography variant="body2" fontWeight="bold">Estado Usuario</Typography>}
                    secondary={<Typography variant="caption" sx={{ color: usuario.esBloqueado ? '#E63946' : '#4CAF50' }}>
                      {usuario.esBloqueado ? 'Bloqueado' : 'Activo'}
                    </Typography>}
                  />
                  <ListItemSecondaryAction>
                    <Tooltip title={usuario.esBloqueado ? "Desbloquear usuario" : "Bloquear usuario"} arrow>
                      <FormControlLabel
                        control={<Checkbox color="error" sx={{ width: 20, height: 20 }} />}
                        name="esBloqueado" checked={usuario.esBloqueado} onChange={handleChange}
                      />
                    </Tooltip>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Box>

        {/* ==================== COLUMNA DERECHA 10/12 ==================== */}
        <Box sx={{ width: { xs: '100%', md: 'calc(83.33% - 24px)' }, flex: 1, minWidth: 0 }}>
          
          {/* Card Datos */}
          <Card sx={{ borderRadius: '16px', border: '2px solid rgba(30, 136, 229, 0.2)', mb: 3 }}>
            <CardHeader
              avatar={<ContactsIcon sx={{ fontSize: 28, color: "#1E88E5" }} />}
              title={<Typography variant="h6" fontWeight="bold" color="#1E88E5">Datos del usuario</Typography>}
              subheader="Digite los datos"
              action={
                <Box display="flex" gap={1}>
                  <Tooltip title="Volver a la lista" arrow>
                    <IconButton onClick={handleVolver} sx={{ color: '#757575' }}>
                      <ArrowBackIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Guardar cambios" arrow>
                    <IconButton onClick={guardarUsuario} sx={{ color: '#4CAF50' }}>
                      <SaveIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Ayuda" arrow>
                    <IconButton onClick={() => handleOpenDialogNotas(1, 'paper')} sx={{ color: '#1E88E5' }}>
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Cancelar cambios" arrow>
                    <IconButton onClick={cancelaGuardar} sx={{ color: '#E63946' }}>
                      <CancelIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
            />
            <CardContent>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, mb: 2 }}>
                
                {/* SECCIÓN 1: Identificación */}
                <Box sx={{ 
                  flex: 1, 
                  minWidth: { xs: '100%', sm: '30%' },
                  p: 2,
                  borderRadius: '12px',
                  border: '2px solid rgba(76, 175, 80, 0.3)',
                  backgroundColor: 'rgba(76, 175, 80, 0.05)'
                }}>
                  <Typography variant="subtitle2" fontWeight="bold" color="#4CAF50" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                    Identificación
                  </Typography>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <FormLabel>Tipo de Documento</FormLabel>
                    <RadioGroup row name="tipoDocumento" value={usuario.tipoDocumento} onChange={handleChange}>
                      <FormControlLabel value="CC" control={<Radio size="small" />} label="CC" />
                      <FormControlLabel value="TI" control={<Radio size="small" />} label="TI" />
                      <FormControlLabel value="NIT" control={<Radio size="small" />} label="NIT" />
                    </RadioGroup>
                  </FormControl>
                  <TextField sx={textFieldStyles} label="Documento" name="documento" fullWidth
                    value={usuario.documento} onChange={handleChange} />
                </Box>
                
                {/* SECCIÓN 2: Ubicación */}
                <Box sx={{ 
                  flex: 1, 
                  minWidth: { xs: '100%', sm: '30%' },
                  p: 2,
                  borderRadius: '12px',
                  border: '2px solid rgba(30, 136, 229, 0.3)',
                  backgroundColor: 'rgba(30, 136, 229, 0.05)'
                }}>
                  <Typography variant="subtitle2" fontWeight="bold" color="#1E88E5" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                    Ubicación
                  </Typography>
                  <TextField 
                    sx={{ ...textFieldStyles, mb: 2 }} 
                    select 
                    label="Departamento" 
                    name="departamentoID"
                    fullWidth
                    value={usuario.departamentoID}
                    onChange={handleChange}
                  >
                    <MenuItem value=""><em>Seleccione...</em></MenuItem>
                    {departamentos.map((depto) => (
                      <MenuItem key={depto.departamentoID} value={depto.departamentoID}>
                        {depto.nombre}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField 
                    sx={textFieldStyles} 
                    select 
                    label="Municipio" 
                    name="municipioID"
                    fullWidth
                    value={usuario.municipioID}
                    onChange={handleChange}
                    disabled={!usuario.departamentoID}
                  >
                    <MenuItem value=""><em>Seleccione...</em></MenuItem>
                    {municipiosFiltrados.map((muni) => (
                      <MenuItem key={muni.municipioID} value={muni.municipioID}>
                        {muni.nombre}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
                
                {/* SECCIÓN 3: Contacto de Emergencia */}
                <Box sx={{ 
                  flex: 1, 
                  minWidth: { xs: '100%', sm: '30%' },
                  p: 2,
                  borderRadius: '12px',
                  border: '2px solid rgba(255, 152, 0, 0.3)',
                  backgroundColor: 'rgba(255, 152, 0, 0.05)'
                }}>
                  <Typography variant="subtitle2" fontWeight="bold" color="#FF9800" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                    Contacto de Emergencia
                  </Typography>
                  <TextField sx={{ ...textFieldStyles, mb: 2 }} label="Nombre Contacto" name="contacto1" fullWidth
                    value={usuario.contacto1} onChange={handleChange} />
                  <TextField sx={textFieldStyles} label="Celular Contacto" name="celularC1" fullWidth
                    value={usuario.celularC1} onChange={handleChange} />
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Contenedor de dos columnas: Direcciones/Roles a la izquierda, QR a la derecha */}
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3 }}>
            
            {/* Columna Izquierda: Direcciones y Roles */}
            <Box sx={{ flex: 1, minWidth: { xs: '100%', md: '65%' }, display: 'flex', flexDirection: 'column', gap: 3 }}>
              
              {/* Card Direcciones */}
              <Card sx={{ borderRadius: '16px', border: '2px solid rgba(30, 136, 229, 0.2)', maxHeight: 250, overflow: 'auto' }}>
                <CardHeader
                  avatar={<HomeWorkIcon sx={{ fontSize: 28, color: "#1E88E5" }} />}
                  title={<Typography variant="h6" fontWeight="bold" color="#1E88E5">Direcciones del usuario</Typography>}
                  action={
                    <Tooltip title="Agregar dirección" arrow>
                      <IconButton onClick={() => handleOpenDialog({ id: 0, calle: '', ciudad: '', departamento: '', codigoPostal: '', pais: '', caracteristica: '', principal: false })}
                        sx={{ color: '#4CAF50' }}>
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  }
                />
                <CardContent>
                  <List>
                    {direcciones.map((dir) => (
                      <ListItem key={dir.id} sx={{ backgroundColor: dir.principal ? 'rgba(30, 136, 229, 0.04)' : 'inherit', borderRadius: '8px', mb: 1 }}>
                        <ListItemText
                          primary={<Typography variant="body2" fontWeight={dir.principal ? 'bold' : 'normal'}>
                            {`${dir.calle}, ${dir.ciudad}, ${dir.departamento}`}
                          </Typography>}
                          secondary={dir.principal ? 'Dirección Principal' : ''}
                        />
                        <ListItemSecondaryAction>
                          <Tooltip title="Editar dirección" arrow>
                            <IconButton onClick={() => handleOpenDialog(dir)} sx={{ color: '#1E88E5' }}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Eliminar dirección" arrow>
                            <IconButton onClick={() => handleEliminarDireccion(dir)} sx={{ color: '#E63946' }}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>

              {/* Card Roles */}
              <Card sx={{ borderRadius: '16px', border: '2px solid rgba(30, 136, 229, 0.2)' }}>
                <CardHeader
                  avatar={<PermContactCalendarIcon sx={{ fontSize: 28, color: "#1E88E5" }} />}
                  title={<Typography variant="h6" fontWeight="bold" color="#1E88E5">Roles de usuario</Typography>}
                  action={
                    <Tooltip title="Editar roles" arrow>
                      <IconButton onClick={handleOpenDialogRoles} sx={{ color: '#FF9800' }}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  }
                />
                <CardContent>
                  <Select
                    components={{ DropdownIndicator: NoDropdownIndicator, ClearIndicator: NoClearIndicator, MultiValueRemove: NoMultiValueRemove }}
                    styles={customStyles()} isMulti options={optionsRoles} value={rolesAsignados} isDisabled={true}
                  />
                </CardContent>
              </Card>
            </Box>

            {/* Columna Derecha: Código QR */}
            <Box sx={{ flex: 0, minWidth: { xs: '100%', md: '30%' }, maxWidth: { xs: '100%', md: '35%' } }}>
              <Card sx={{ borderRadius: '16px', border: '2px solid rgba(156, 39, 176, 0.2)', height: '100%' }}>
                <CardHeader
                  title={<Typography variant="h6" fontWeight="bold" color="#9C27B0">Tarjeta de Presentación</Typography>}
                  subheader={<Typography variant="body2" color="text.secondary">Código QR para compartir</Typography>}
                  action={
                    <Box display="flex" gap={0.5}>
                      <Tooltip title="Ver tarjeta de presentación" arrow>
                        <IconButton 
                          onClick={() => window.open(`/tarjeta/${id}`, '_blank')}
                          sx={{ 
                            color: '#9C27B0',
                            '&:hover': { backgroundColor: 'rgba(156, 39, 176, 0.1)' }
                          }}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Descargar QR" arrow>
                        <IconButton 
                          onClick={() => {
                            const canvas = document.querySelector('#qr-canvas');
                            if (canvas) {
                              const url = canvas.toDataURL('image/png');
                              const link = document.createElement('a');
                              link.download = `qr-${usuario.nombre}-${usuario.apellido}.png`;
                              link.href = url;
                              link.click();
                            }
                          }}
                          sx={{ 
                            color: '#1E88E5',
                            '&:hover': { backgroundColor: 'rgba(30, 136, 229, 0.1)' }
                          }}
                        >
                          <FileDownload fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Copiar URL" arrow>
                        <IconButton 
                          onClick={() => {
                            const url = `${window.location.origin}/tarjeta/${id}`;
                            navigator.clipboard.writeText(url);
                            setSuccessMessage('URL copiada al portapapeles');
                            setTimeout(() => setSuccessMessage(''), 2000);
                          }}
                          sx={{ 
                            color: '#4CAF50',
                            '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' }
                          }}
                        >
                          <ContentCopy fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  }
                />
                <CardContent sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  py: 3,
                  '& canvas': {
                    maxWidth: '150px !important',
                    maxHeight: '150px !important',
                    width: '150px !important',
                    height: '150px !important'
                  },
                  '& img': {
                    maxWidth: '150px !important',
                    maxHeight: '150px !important',
                    width: '150px !important',
                    height: '150px !important'
                  },
                  '& > div': {
                    maxWidth: '150px !important'
                  },
                  '& p, & span, & .MuiTypography-root, & button': {
                    display: 'none !important'
                  }
                }}>
                  <QRCardComponent userId={id} userName={`${usuario.nombre} ${usuario.apellido}`} />
                </CardContent>
              </Card>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* DIÃƒÂLOGOS */}
      <Dialog open={openDialog} onClose={handleCloseDialog} TransitionComponent={Transition} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
        <DialogTitle><Typography variant="h6" fontWeight="bold" color="#1E88E5">{direccion.id ? 'Editar' : 'Crear'} Dirección</Typography></DialogTitle>
        <DialogContent dividers>
          <TextField margin="dense" label="Calle" name="calle" fullWidth value={direccion.calle} onChange={handleChangeDir} sx={textFieldStyles} />
          <TextField margin="dense" label="Ciudad" name="ciudad" fullWidth value={direccion.ciudad} onChange={handleChangeDir} sx={textFieldStyles} />
          <TextField margin="dense" label="Departamento" name="departamento" fullWidth value={direccion.departamento} onChange={handleChangeDir} sx={textFieldStyles} />
          <TextField margin="dense" label="Código Postal" name="codigoPostal" fullWidth value={direccion.codigoPostal} onChange={handleChangeDir} sx={textFieldStyles} />
          <TextField margin="dense" label="País" name="pais" fullWidth value={direccion.pais} onChange={handleChangeDir} sx={textFieldStyles} />
          <TextField margin="dense" label="Característica" name="caracteristica" fullWidth value={direccion.caracteristica} onChange={handleChangeDir} sx={textFieldStyles} />
          <FormControlLabel control={<Checkbox checked={direccion.principal} name="principal" onChange={handleChangeDir} />} label="Principal" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} sx={{ borderRadius: '12px' }}>Cancelar</Button>
          <Button onClick={() => handleGuardar(direccion)} variant="contained" sx={{ borderRadius: '12px', backgroundColor: '#1E88E5' }}>Guardar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Roles con altura ajustada */}
      <Dialog 
        open={openDialogRoles} 
        onClose={handleCloseDialogRoles} 
        TransitionComponent={Transition} 
        maxWidth="md" 
        fullWidth 
        PaperProps={{ 
          sx: { 
            borderRadius: '16px',
            minHeight: '400px',
            maxHeight: '600px'
          } 
        }}
      >
        <DialogTitle><Typography variant="h6" fontWeight="bold" color="#1E88E5">Editar Roles</Typography></DialogTitle>
        <DialogContent dividers sx={{ minHeight: '300px' }}>
          <Select 
            styles={customStyles()} 
            menuIsOpen={true} 
            components={animatedComponents} 
            isMulti 
            options={optionsRoles} 
            value={rolesAsignados} 
            onChange={handleChangeRoles}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogRoles}>Cancelar</Button>
          <Button onClick={() => handleGuardarRoles(rolesAsignados)} variant="contained" sx={{ backgroundColor: '#1E88E5' }}>Guardar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialogNota} onClose={handleCloseDialogNota} TransitionComponent={Transition} scroll={scroll} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6" fontWeight="bold" color="#1E88E5">Observaciones</Typography>
            <Tooltip title="Cerrar" arrow>
              <IconButton onClick={handleCloseDialogNota}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <Typography paragraph><div dangerouslySetInnerHTML={{ __html: nota.contenido }} /></Typography>
        </DialogContent>
        <DialogActions><Button onClick={handleCloseDialogNota}>Cerrar</Button></DialogActions>
      </Dialog>

      <Dialog open={openPass} onClose={handleClosePassword} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
        <DialogTitle><Typography variant="h6" fontWeight="bold" color="#1E88E5">Cambiar Contraseña</Typography></DialogTitle>
        <DialogContent dividers>
          <TextField label="Nueva Contraseña" type="password" fullWidth sx={{ ...textFieldStyles, mb: 2 }} name="password" onChange={handleChange} />
          <TextField label="Confirmar Contraseña" type="password" fullWidth sx={textFieldStyles} name="confirmPassword" onChange={handleChangeConfirm} error={error !== ''} helperText={error} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePassword}>Cancelar</Button>
          <Button onClick={guardarUsuario} variant="contained" disabled={error !== '' || !usuario.password} sx={{ backgroundColor: '#1E88E5' }}>Guardar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default EditarUsuario;